import * as React from "react"

function SvgComponent(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.3 14.63" {...props}>
      <g data-name="Capa 2">
        <path
          d="M9.43 6a.57.57 0 01.57-.58h1.1v-1.1a.58.58 0 01.57-.58.57.57 0 01.57.58v1.1h1.11a.57.57 0 01.57.57.58.58 0 01-.57.57h-1.11v1.1a.57.57 0 01-.57.57.58.58 0 01-.57-.57v-1.1H10A.58.58 0 019.43 6zM7.6 8.31l1.05.89a.56.56 0 00.35.13h1.66a.48.48 0 110 .95H8.43a.58.58 0 000 1.15h2.25a1.6 1.6 0 001-.34l3.91-1.42a.46.46 0 01.6.28.53.53 0 01-.33.63l-5.52 2.69a1.93 1.93 0 01-1.69 0l-3.1-1.37a.46.46 0 00-.23-.05h-.26V8.31zM6.88 6.6a4.67 4.67 0 01-.56-3.46A2.67 2.67 0 017.78 1.4a2.53 2.53 0 013.38 1.15.58.58 0 00.77.25.51.51 0 00.25-.25 2.55 2.55 0 013.39-1.15A2.67 2.67 0 0117 3.14a4.67 4.67 0 01-.56 3.46 9.2 9.2 0 01-2.19 2.29h-.06l-1.93.71a1.62 1.62 0 00-1.61-1.46H9.23l-.91-.77a1.06 1.06 0 00-.7-.26h-.33C7.14 7 7 6.79 6.88 6.6M3.92 13H1.14V7.33h2.78zm.57-6.8H.57a.57.57 0 00-.57.56v6.81a.58.58 0 00.57.57h3.92a.57.57 0 00.57-.57V13h.13l3 1.35a3 3 0 002.66 0l5.52-2.69a1.66 1.66 0 00.91-2 1.6 1.6 0 00-.84-.91l-.1-.05a8.66 8.66 0 001.1-1.38 5.81 5.81 0 00.71-4.39A3.8 3.8 0 0016.07.37a3.69 3.69 0 00-4.4.9 3.68 3.68 0 00-4.39-.9 3.78 3.78 0 00-2.06 2.46 5.78 5.78 0 00.67 4.33h-.83v-.4a.56.56 0 00-.57-.57"
          fill="#003da6"
          data-name="Capa 1"
        />
      </g>
    </svg>
  )
}

export default SvgComponent
